import {
    OpenRequestFinancingCategoriesSalesforce,
    OpenRequestGeneralCategoriesSalesforce,
    SelectItemLabelValueCategories,
} from '@cp-es/common';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-10/frontend-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const financingCategories: SelectItemLabelValueCategories[] = [
    ['title-retention', OpenRequestFinancingCategoriesSalesforce.TITLE_RETENTION],
    ['early-settlement', OpenRequestFinancingCategoriesSalesforce.EARLY_SETTLEMENT],
    ['change-contact-details', OpenRequestFinancingCategoriesSalesforce.CHANGE_CONTACT_DETAILS],
    ['unpaid-balance', OpenRequestFinancingCategoriesSalesforce.UNPAID_BALANCE],
    ['contract-information', OpenRequestFinancingCategoriesSalesforce.CONTRACT_INFORMATION],
    ['sepa-mandate', OpenRequestFinancingCategoriesSalesforce.SEPA_MANDATE],
];

export const FinancingDropdown: React.FC<{ name: string; isFinanceLeaseContract?: boolean }> = ({
    name,
    isFinanceLeaseContract,
}) => {
    const { t } = useTranslation('my-request');
    // ES-16 different label but the same value for salesforce

    let categories = [...financingCategories];

    if (isFinanceLeaseContract) {
        categories = [['other-issues-leasing', OpenRequestGeneralCategoriesSalesforce.OTHER_ISSUES_LEASING]]; // ES-16 CO-23065 missing API implementation
    } else {
        categories.push(['other-issues-financing', OpenRequestFinancingCategoriesSalesforce.OTHER_ISSUES_FINANCING]);
    }

    const validatedSelectItems: ValidatedSelectItem[] = categories.map(category => {
        const categoryEntryText = t(`form.financing-categories.${category[0]}`);
        return {
            label: categoryEntryText,
            value: category[1],
        };
    });

    return (
        <>
            <ValidatedSelect
                className="c-form-field--no-floating"
                label={t('form.category.headline')}
                name={name}
                selectItems={validatedSelectItems}
                testId={`finance-${name}`}
                placeholder={t('form.category.placeholder')}
                disablePlaceholder={true}
            />
        </>
    );
};
